import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Select } from '@ngxs/store';
import { VehicleOptionsMetaData, OptionsAccessoriesComponent } from 'remarketing-ui-components-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { DetailsQueries } from 'src/sell/lib/details/queries/details.queries';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-auto-vision-equipment-accessories',
    templateUrl: './auto-vision-equipment-accessories.component.html',
    styleUrls: ['./auto-vision-equipment-accessories.component.scss'],
    imports: [OptionsAccessoriesComponent, AsyncPipe]
})
export class AutoVisionEquipmentAccessoriesComponent extends SaComponent implements OnInit {
  @Input() variant: 'carousel' | 'static' | 'long-descriptions-mobile';
  @Select(DetailsQueries.equipmentAccessories) options$: Observable<VehicleOptionsMetaData>;
  @Select(DetailsQueries.equipmentLongDescriptions) longDescriptions$: string[];

  maxEquipRows = 4;
  autoVisionEquipmentAccessoriesTranslations = {
    dataObject: '',
    optionsAndAccessories: '',
  };

  constructor(private readonly translocoService: TranslocoService) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  getTranslations() {
    const keyParams = {
      'UIComponents.optionAccessories': {},
      'sellModule.details.equipmentAccessories': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translate => {
        this.autoVisionEquipmentAccessoriesTranslations.dataObject = translate[0];
        this.autoVisionEquipmentAccessoriesTranslations.optionsAndAccessories = translate[1].optionsAndAccessories;
      });
  }
}
